import React from "react";
import { Link } from 'react-router-dom';
import './listing.css';
const ListingDisplay = (props) => {

    const renderData = ({ listData }) => {
        if (listData) {
            if (listData.length > 0) {
                return listData.map((item) => {
                    return (
                        <div className="card col-md-4 mb-2 bb " key={item._id}>
                            <div className="img-container">
                                <div className="d-flex justify-content-between align-items-center p-2 first">
                                    <span className="percent bg-warning percss" >-{item.Brand_id}%</span>
                                    <span className="wishlist">
                                        <i className="fa fa-heart"></i>
                                    </span>
                                </div>
                                <Link to={`/details?prodId=${item.id}`}>
                                <img src={item.Image} className="img-fluid imghw" />
                                </Link>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mt-2 ms-1">
                                <div className="ratings">
                                    <i className="fa fa-star"></i>
                                    <span className="starli">{item.id}</span>
                                </div>
                            </div>
                            <div className="mt-4 mb-1 ms-1">
                                <Link to={`/details?prodId=${item.id}`}  style={{ textDecoration: 'none'}}>
                                    <h5 className="text-uppercase biketitle">{item.product_name}</h5>
                                </Link>
                            </div>
                            <div className="price d-flex flex-row ms-1 align-items-center">
                                <span className="pricelist fw-bold mb-1">₹ {item.Price}</span>
                            </div>
                            <div>
                            <Link to={`/details?prodId=${item.id}`}>
                                <button type="button" className="btn btn-outline-dark ms-1 w-50 btnli">Book now</button>
                            </Link>   
                                <i className="fa fa-shopping-cart text-muted ms-2"></i>
                                <i className="fa fa-share-alt text-muted ms-2"></i>
                            </div>
                        </div>
                    )
                })
            } else {
                return (
                    <div>
                        < div className="lodar" >
                            <h2>!no! data As per This Option</h2>
                            <img src="https://stories.freepiklabs.com/storage/18539/no-data-pana-1440.png"></img>
                        </div>
                    </div>
                )
            }
        } else {
            return (
                < div className="lodar" >
                    <img src="https://i.ibb.co/k6XQRTk/17469.gif" className="gif" alt="loder" />
                    <h1>loding...</h1>
                </div>
            )
        }
    }
    return (
        <div id="" className='row   '>
            {renderData(props)}
        </div>
    )
}

export default ListingDisplay;